module.exports = __webpack_public_path__ + "img/icon_R3.19b34e30.png";